import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddUom.css";
import { createUom } from "../../../../services/UOM/uom.service";
import { toast } from "react-toastify";

const AddUom: React.FC = () => {
  const [uomName, setUomName] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!uomName.trim()) {
      toast.error("UOM name is required");
      return;
    }

    try {
      await createUom(uomName, description);
      toast.success("UOM added successfully");
      navigate("/uom/list");
    } catch (error) {
      toast.error("Failed to create UOM");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div className="modal-header">
          <h2>Add New UOM</h2>
          <span className="close-btn" onClick={() => navigate(-1)}>✕</span>
        </div>

        <p className="subtitle">Enter the details for the new UOM.</p>

        <form onSubmit={handleSubmit}>
          <label>UOM Name *</label>
          <input
            type="text"
            placeholder="Enter UOM name"
            value={uomName}
            onChange={(e) => setUomName(e.target.value)}
          />

          <label>Description</label>
          <input
            type="text"
            placeholder="Enter description (optional)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button type="submit" className="add-btn">
              Add UOM
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUom;
